import styled from '@emotion/styled'
import { HTMLAttributes, PropsWithChildren } from 'react'
import { joinClasses } from './joinClasses'

const ExtranetTableRowGroupRoot = styled.div`
  display: flex;
  flex-direction: column;
`

type ExtranetTableRowGroupProps = PropsWithChildren & HTMLAttributes<HTMLDivElement>

export const ExtranetTableRowGroup = ({ children, ...props }: ExtranetTableRowGroupProps) => {
  return (
    <ExtranetTableRowGroupRoot
      className={joinClasses('entable__row entable__row--group', props.className)}
      {...props}
    >
      {children}
    </ExtranetTableRowGroupRoot>
  )
}
